module.exports = __webpack_public_path__ + "static/eldath-symbol-SCAG-b472990a21ee2fed16c90299b0a386c8.png";